import { TermsIndexResource } from "@/api/resources";

export function getTerms({ propertyId, lang }) {
  return TermsIndexResource.get({ propertyId, lang });
}
